import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

// Third-party CSS is loaded once, here, so the design system in App.scss
// always wins the cascade. (It used to be imported from inside components.)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-medium-image-zoom/dist/styles.css';
import 'react-phone-number-input/style.css';

import App from './App';
import './App.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>
);
